export default __webpack_public_path__ + "static/media/29.7fb1520c.png";